import { render, staticRenderFns } from "./isolate-info.vue?vue&type=template&id=59c6a782&scoped=true&"
import script from "./isolate-info.vue?vue&type=script&lang=js&"
export * from "./isolate-info.vue?vue&type=script&lang=js&"
import style0 from "./isolate-info.vue?vue&type=style&index=0&id=59c6a782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6a782",
  null
  
)

export default component.exports